import React from 'react'
import {Link} from 'react-router-dom';
import './css/Newscomp.css';
import bed from '../assets/bed.svg';
import lastimg from '../assets/lastimg.jpeg';
import dot from '../assets/dot.svg';
import mailplus from '../assets/mailplus.svg';

const Newscomp = () => {
    const newsdata = [
        {
            img: bed,
            heading: 'Latest Trends in Custom Wood Furniture Design',
            para: 'Explore the newest trends in custom woodworking and furniture design. Discover how traditional craftsmanship meets modern aesthetics in creating timeless pieces for your space.',
            created: 'Created: 2024-01-15'
        },
        {
            img: lastimg,
            heading: 'Sustainable Woodworking Practices at Dhiman',
            para: 'Learn about our commitment to sustainable woodworking practices. From material selection to finishing techniques, we ensure every piece reflects our dedication to environmental responsibility.',
            created: 'Created: 2024-01-10'
        }
    ]

    return (
        <section className='news-main-div'>
            <div className='newscomp-main-div-content1'>
                <div className='heading-div-content'>
                    <h1 className='newscomp-heading'>Woodworking Insights</h1>
                    <p className='newscomp-para'>Expert tips and updates from our master craftsmen</p>
                </div>
                <div className='newscomp-main-div-content2'>
                    <div className='newscomp-main-div-content2-content'>
                        {newsdata.map((item, index) => (
                            <div className='newscomp-map-content' key={index}>
                                <div className='newcomp-image-div'>
                                    <img src={item.img} alt={item.heading}/>
                                </div>
                                <div className='newscomp-text-map-div'>
                                    <h2 className='newscomp-text-map-div-heading'>{item.heading}</h2>
                                    <div className='newscomp-text-map-div-para'>
                                        <img src={dot} alt="date indicator" />
                                        <p className='newscomp-text-map-div-para-content'>{item.created}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <button className='button-89-2'>View All Articles</button>
                    </div>
                    <div className='newscomp-main-div-content2-content2'>
                        <img src={mailplus} alt="newsletter signup" />
                        <h2 className='newscomp-main-div-content2-content2-heading-head'>Get Woodworking Updates</h2>
                        <form className='form-newscomp'>
                            <input type="email" placeholder='Your email for craft updates' className='button-89' />
                            <button className='newscomp-btn'>Join Now</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Newscomp
